module.exports = __webpack_public_path__ + "img/smart-plug-sm.a11d6999.svg";